import _ from "lodash"
import { useState, useRef } from "react"
import { _getAllVehicleVariant } from "../../libraries/common";
import { HeaderBack } from '@/components/common/header';
import { CompareResult } from "../compare";
import { Footer } from "../common/footer";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../body/body";

export const VehicleSpec = (props) => {
    const { t, device, session, fetchedData } = props;

    // compare
    const containerRef = useRef(null)
    const [compareData, setCompareData] = useState(fetchedData ?? [])

    return (
        <>
            <AllMeta
                title={t('vehicleBrandModelSpecPage_meta_title', { brandModel: fetchedData?.[0]?.model_name })}
                description={t('vehicleBrandModelSpecPage_meta_description', { brand: fetchedData?.[0]?.brand_name,  brandModel: fetchedData?.[0]?.model_name })}
                keyword={t('vehicleBrandModelSpecPage_meta_keyword', { brandModel: fetchedData?.[0]?.model_name})}
                image={!_.isEmpty(fetchedData?.[0]?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.[0]?.cover_image_path}` : undefined}
                imageWidth={1275}
                imageheight={666}
            />
            <Head><title>{t('vehicleBrandModelSpecPage_title', {brandModel: fetchedData?.[0]?.model_name})}</title></Head>
            <MyBody
                t={t}
                containerRef={containerRef}
                containerStyle={{overflowX: "hidden"}}
                headerComponent={
                    <HeaderBack t={t} searchVisible={false} />
                }
                showFooter={false}
            >
                
                <CompareResult
                    t={t} 
                    title={"Tile"}
                    containerRef={containerRef}
                    setCompareData={setCompareData}
                    compareData={compareData}
                    isByModel={true}
                />
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('vehicleBrandModelSpecPage_meta_title', { brandModel: fetchedData?.[0]?.model_name })}
    //             description={t('vehicleBrandModelSpecPage_meta_description', { brand: fetchedData?.[0]?.brand_name,  brandModel: fetchedData?.[0]?.model_name })}
    //             keyword={t('vehicleBrandModelSpecPage_meta_keyword', { brandModel: fetchedData?.[0]?.model_name})}
    //             image={!_.isEmpty(fetchedData?.[0]?.cover_image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.[0]?.cover_image_path}` : undefined}
    //             imageWidth={1275}
    //             imageheight={666}
    //         />
    //         <Head><title>{t('vehicleBrandModelSpecPage_title', {brandModel: fetchedData?.[0]?.model_name})}</title></Head>
    //         <div className="bodyContainer">
    //             <div ref={containerRef} className="contentContainer" style={{overflowX: "hidden"}}>
    //                 <HeaderBack t={t} searchVisible={false} />
    //                 <CompareResult
    //                     t={t} 
    //                     title={"Tile"}
    //                     containerRef={containerRef}
    //                     setCompareData={setCompareData}
    //                     compareData={compareData}
    //                     isByModel={true}
    //                 />
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </>
    // )
}